<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card class="mb-6" :title="$t('HolidayPlan') | ToUppercase">
            <vs-button class="" color="success" type="filled" to="/holiday-plan/add">{{$t('AddPlan')}}</vs-button>
            
            <div class="vx-row">
                <vs-divider/>
                <div class="vx-col sm:w-1/2 md:w-2/5 w-full">
                    <small>{{$t('DateFrom') |ToUppercase}}</small><br>
                    <datepicker v-model="dateFrom"></datepicker>
                </div>
                <div class="vx-col sm:w-1/2 md:w-2/5 w-full">
                    <small>{{$t('DateTo') |ToUppercase}}</small><br>
                    <datepicker v-model="dateTo"></datepicker>
                </div>
                <div class="vx-col sm:w-1/2 md:w-1/5 w-full">
                    <vs-button class="mt-6" color="success" type="filled" @click="searchHolidayPlans()">{{$t('Search')}}</vs-button>
                </div>
            </div>

            <vs-table :noDataText="$t('NoHolidayPlansFound')" max-items="14" pagination search :data="holidayPlans">
                <template slot="thead">
                    <vs-th sort-key="id">#</vs-th>
                    <vs-th sort-key="id">{{ $t("User") }}</vs-th>
                    <vs-th sort-key="id">{{ $t("DateFrom") }}</vs-th>
                    <vs-th sort-key="id">{{ $t("DateTo") }}</vs-th>
                    <vs-th sort-key="id">{{ $t("Explanation") }}</vs-th>
                    <vs-th sort-key="id">{{ $t("PlanConfirmed") }}</vs-th>
                    <vs-th v-if="admin == 'admin'" sort-key="id">{{ $t("Actions") }}</vs-th>
                </template>
                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :data="tr" :key="data[index].id" v-for="(tr, index) in data">
                            <vs-td>{{ data[index].id}}</vs-td>
                            <vs-td>{{ data[index].user_name}}</vs-td>
                            <vs-td>{{ data[index].date_from_formated}}</vs-td>
                            <vs-td>{{ data[index].date_to_formated}}</vs-td>
                            <vs-td>{{ data[index].explanation}}</vs-td>
                            <vs-td>
                                <vs-chip :color="getHolidayPlanStatusColor(data[index].confirmed)"></vs-chip>
                            </vs-td>
                            <vs-td v-if="admin == 'admin'" class="grid justify-items-start">
                                <vs-button color="primary" class="float-left mr-2" @click="$router.push('/holiday-plan/edit/' + data[index].id)" type="border" icon="build" >{{$t('Edit') | ToUppercase}}</vs-button>
                                <vs-button color="primary" class="float-left mr-2" @click="deleteHolidayPlan(data[index].id)" type="border" icon="delete" >{{$t('Delete') | ToUppercase}}</vs-button>
                                <vs-button v-if="data[index].confirmed === false" color="primary" class="float-left" @click="confirmHolidayPlan(data[index].id)" type="border" icon="build" >{{$t('Confirm') | ToUppercase}}</vs-button>
                            </vs-td>
                        </vs-tr>
                    </tbody>
                </template>
            </vs-table>
            </vx-card>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    export default {
        filters: {
            ToUppercase: function (value) {
                if (!value) return "";
                value = value.toString();
                return value.toUpperCase();
            },
        },
        components: {
            Datepicker
        },
        data() {
            return {
                holidayPlans: [],
                dateFrom: null,
                dateTo: null,
                userId: 0,
                admin: '',
            };
        },
        methods: {
            searchHolidayPlans() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.post('/holiday-plan/search', {
                    date_from: new Date(thisIns.dateFrom.getFullYear(), thisIns.dateFrom.getMonth(), thisIns.dateFrom.getDate(), 0, 0, 0),
                    date_to: new Date(thisIns.dateTo.getFullYear(), thisIns.dateTo.getMonth(), thisIns.dateTo.getDate(), 23, 59, 59),
                }).then(function (response) {
                    thisIns.holidayPlans = response.data;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju dopustov",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            getHolidayPlanStatusColor(status) {
                if (status === true) return 'success'
                if (status === false) return 'danger'
                return 'primary'
            },
            confirmHolidayPlan(id) {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/holiday-plan/confirm/' + id)
                .then(function (response) {
                    thisIns.$vs.notify({
                        text: "Dopust potrjen",
                        color: "success",
                    });
                    thisIns.searchHolidayPlans();
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri potrjevanju dopusta",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            deleteHolidayPlan(id) {
                this.$vs.loading();
                
                const thisIns = this;
                this.$http.delete('/holiday-plan/' + id)
                .then(function (response) {
                    thisIns.$vs.notify({
                        text: "Dopust izbrisan",
                        color: "success",
                    });
                    thisIns.searchHolidayPlans();
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri brisanju dopusta",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            }
        },
        created() {
            const userInfo = JSON.parse(localStorage.getItem("userInfo"));
            this.userId = userInfo.uid;
            this.admin = userInfo.userRole;

            var date = new Date();
            this.dateFrom = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0);
            this.dateTo = new Date(date.getFullYear(), date.getMonth() + 1, 0, 0, 0, 0);

            this.searchHolidayPlans();
        },
    };
</script>